import request from '@/utils/request'
const BASE_URL = '/StInDoc'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(id) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'get',
      params: { id }
    })
  },
  examine(id) {
    return request({
      url: BASE_URL + '/Examine',
      method: 'get',
      params: { id }
    })
  },
  cancelExamine(id) {
    return request({
      url: BASE_URL + '/CancelExamine',
      method: 'get',
      params: { id }
    })
  },
  getGoodsList(id) {
    return request({
      url: BASE_URL + '/GetGoodsList',
      method: 'get',
      params: { id }
    })
  },
  export(data) {
    return request({
      url: BASE_URL + '/Export',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // 

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  },
}